module.exports = __webpack_public_path__ + "static/media/iReForm.3633bbca.jpg";